<!--操作计划-->
<template>
  <div class="fallback-ad-edit">
    <head-panel title="打底广告" subtitle="AD SERVING" :exportExc="false"></head-panel>
    <h3 class="panel-content__title">
      <span class="is-active" @click="$router.push({ name: 'advertiseList' })">打底广告</span>
      <span class="is-separator">&gt;</span>
      <span>{{type === 'edit' ? '编辑' : (type === 'view' ? '查看': '新增')}}广告</span>
    </h3>
    <div class="formPanel">
      <el-form
        class="ruleForm"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="12%"
        v-loading="loading"
      >
        <el-form-item label="打底广告名称" prop="ad_name">
          <el-input v-model="form.ad_name" class="taskInput" placeholder="请输入打底广告名称"></el-input>
        </el-form-item>
        <el-form-item label="广告标题" prop="title">
          <el-input v-model="form.title" class="taskInput" placeholder="请输入广告标题"></el-input>
        </el-form-item>
        <el-form-item label="广告描述" prop="spread_name">
          <el-input v-model="form.spread_name" class="taskInput" placeholder="请输入广告描述"></el-input>
        </el-form-item>
        <el-form-item label="流量类型" prop="flow_type">
          <el-radio-group v-model="form.flow_type" @change="flowTypeChange" :disabled="!isAdd">
            <el-radio
              :label="item.value"
              v-for="(item,key) in fallback.flowTypeMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="投放终端" prop="port_type">
          <el-radio-group v-model="form.port_type" @change="portTypeChange" :disabled="!isAdd">
            <el-radio
              :label="item.value"
              v-for="(item,key) in fallback.portTypeMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="广告位属性" prop="place_attribute">
          <el-radio-group
            v-model="form.place_attribute"
            @change="placeAttrChange"
            class="rule_form_radio"
            :disabled="!isAdd"
          >
            <el-radio
              :label="item.value"
              v-for="(item,key) in fallback.placeAttrMenu"
              :key="key"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 素材管理 start -->
        <up-form-item-radio
          prop="jump_type"
          label="跳转行为"
          v-model="form.jump_type"
          :data="fallback.jumpTypes"
          :disabled="disabledField"
          @change="handleChangeJumpType"
        ></up-form-item-radio>
        <up-form-item-input
          v-if="form.jump_type === '2' && isAndroid"
          prop="apk_name"
          class="w364"
          label="包名"
          v-model="form.apk_name"
          placeholder="请输入包名"
        >
        <template slot="label">
            包名
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                请联系客户侧技术人员获取
                <br />同一App在不同的应用商店可能使用的不同包名
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-input>
        <up-form-item-input
          v-if="form.jump_type === '2' && isIos"
          prop="apk_name"
          class="w364"
          label="AppID"
          v-model="form.apk_name"
          placeholder="请输入AppID"
          :rules="rules.app_id"
        >
        <template slot="label">
            AppID
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                由于无需访问落地页，若客户有监测需求请用异步监测
                <br /> - 如何获取App ID：
                <p>
                  方法1：通过七麦（
                  <el-link href="https://www.qimai.cn/" type="primary" :underline="false" target="_blank">https://www.qimai.cn/</el-link>
                  ）搜索应用查看应用信息中的App ID
                </p>
                <p>
                  方法2：在AppStore（
                  <el-link href="https://www.apple.com.cn/ios/app-store/" type="primary" :underline="false" target="_blank">https://www.apple.com.cn/ios/app-store/</el-link>
                  ）搜索应用打开后通过URL尾部中的纯数字查看
                </p>
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-input>
        <up-form-item-input
          v-if="form.jump_type === '3'"
          prop="deeplink"
          class="w364"
          label="deeplink"
          v-model="form.deeplink"
          placeholder="请输入deeplink"
        >
          <template slot="label">
            deeplink
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                若用户已安装目标APP，用户点击广告后将直接打
                <br />开APP或跳转到APP指定页面，若您的广告不需此
                <br />功能请不要填写此项，以免造成跳转异常
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-input>
        <!-- 落地页转化检测移除 -->
        <!-- <up-form-item-radio
          prop="conversion_monitor_type"
          v-if="form.jump_type !== '2'"
          label="落地页转化监测"
          v-model="form.conversion_monitor_type"
          :data="conversionMonitorTypes"
        ></up-form-item-radio> -->
        <up-form-item class="w364" v-if="!(isIos && form.jump_type === '2')" prop="ad_url" label="落地页URL：">
          <up-input v-model="form.ad_url" placeholder="请输入落地页URL" @change="handleAdUrlChange"></up-input>
          <up-tooltip effect="light" placement="right">
            <div slot="content">系统会在链接地址后添加安全无害的效果统计参数，请点击验证添加后的地址有效。</div>
            <up-button class="ml5 mr10" type="primary" @click="openAdUrl">预览</up-button>
          </up-tooltip>
          <template>
            <template>
              <span
                v-if="adUrlTxt && !checking"
                class="fallback-ad-edit__landpage-message"
                :class="`${validAdUrl ?'is-correct' : 'is-wrong' }`"
              >{{ `${validAdUrl ? '√' : '×'} ${adUrlTxt}` }}</span>
              <i v-if="checking" class="el-icon el-icon-loading"></i>
            </template>
          </template>
        </up-form-item>
        <up-form-item prop="provinces" label="投放地域">
          <ny-area
            style="margin-left: 16px;"
            :default-value="defaultProvinces"
            v-model="form.provinces"
            v-bind="provinces"
            :disabled="disabledField"
            @change="handleProvinceChange"
          ></ny-area>
        </up-form-item>
        <!-- <up-form-item prop="landing_page_pic">
          <div class="fallback-ad-edit__landpage">
            <up-upload
              class="fallback-ad-edit__landpage-upload"
              action="whatever"
              ref="upload"
              :file-list="fileList"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleOnChangeAdUrl"
              :disabled="disabledAdUrl"
            >
              <up-button
                size="small"
                type="primary"
                :style="{ 'cursor': disabledAdUrl ? 'not-allowed' : 'pointer' }"
                :disabled="disabledAdUrl"
              >
                {{ form.landing_page_pic ? '重新上传落地页长截图' : '上传落地页长截图' }}
                <i
                  class="el-icon-upload el-icon--right"
                ></i>
              </up-button>
            </up-upload>
            <div class="fallback-ad-edit__landpage-tip">
              <up-tooltip effect="light" placement="right">
                <div slot="content">如链接为直接下载类链接，需上传应用内截图；如果是H5页面，需要提供落地页长截图。</div>
                <i class="icon iconfont icon-iconfontquestion"></i>
              </up-tooltip>
              <span class="item">格式：PNG或JPG，大小：小于150KB</span>
            </div>
            <div class="fallback-ad-edit__landpage-pic" v-show="form.landing_page_pic">
              <img :src="form.landing_page_pic" />
            </div>
          </div>
        </up-form-item>-->
        <!-- supportedInformations -->
        <!--  <up-form-item prop="information" label="信息流展示样式" v-if="isFlow">
          <up-radio-group
            v-model="form.information"
            :disabled="disabledField"
            @up:radio-group:change="handleInformationChange"
          >
            <up-radio
              v-for="item in data.informations"
              :key="item.value"
              :label="item.value"
              :disabled="!supportedInformations.includes(item.value)"
            >{{item.name}}</up-radio>
          </up-radio-group>
        </up-form-item>-->
        <up-form-item label="素材上传" prop="filenames" :show-message="false">
          <div
            class="fallback-ad-edit__upload-tip"
          >{{ form.information === '2' ? '组图素材必须上传三张图片' : '为了让素材更好的适配不同宽高比的广告位，建议您上传如下多个不同比例的素材，系统会根据广告位宽高比适配并下发最合适比例的创意' }}</div>
          <up-table
            class="fallback-ad-edit__table"
            border
            align="center"
            :page="page"
            :width-columns="{ no: '80px', material: '160px', material_size: '160px', upload_status: '100px' }"
            :slot-contents="['material', 'material_size', 'material_name', 'upload_status']"
            @cell-click="handleCellClick"
          >
            <template slot="material:content" slot-scope="{ row }">
              <template v-if="row.material">
                <video v-if="row.material.endsWith('.mp4')" src="row.material" controls></video>
                <img v-else class="fallback-ad-edit__table-material" :src="row.cut_path" />
              </template>

              <img v-else class="fallback-ad-edit__table-material" :src="defaultMaterialImage" alt />
            </template>
            <template slot="material_size:content" slot-scope="{ row }">
              <template v-if="isMotivate || isBanner">
                <div
                  class="adput-creation-add__table-material-size"
                >{{ row.create_type === 1 ? '图片' : '视频' }}（素材类型）</div>
                <div
                  class="adput-creation-add__table-material-size"
                >{{ materialTypes[row.material_type] }}（素材内容）</div>
              </template>
              <div class="adput-creation-add__table-material-size">
                {{ row.minimum_upload_size }}
                <span
                  :class="{ 'is-recommend': row.is_recommend === 1 }"
                >（{{ row.is_recommend === 1 ? '推荐尺寸' : '选传尺寸' }}）</span>
              </div>

              <div class="fallback-ad-edit__table-material-size" v-if="row.material_size">
                {{ row.material_size }}
                <span>（原尺寸）</span>
              </div>
              <p class="fallback-ad-edit__table-remark">{{ row.remark }}</p>
            </template>
            <template slot="material_name:content" slot-scope="{ row }">
              <a
                v-if="row.material"
                :href="row.material"
                class="panel-content__table-link"
                target="_blank"
              >{{ row.material }}</a>
              <span>-</span>
            </template>
            <template
              slot="upload_status:content"
              slot-scope="{ row }"
            >{{ row.material ? '已上传' : '待上传' }}</template>
            <template slot="up:operate">
              <up-table-column label="操作" width="120px">
                <template slot-scope="scope">
                  <up-upload
                    class="fallback-ad-edit__replace"
                    action="whatever"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="(file, fileList) => handleOnChange(file, fileList, scope)"
                    :disabled="uploading[scope.$index]"
                  >
                    <up-button size="small" type="primary">
                      {{ scope.row.material ? '替换' : '上传' }}
                      <i
                        v-if="uploading[scope.$index]"
                        class="el-icon el-icon-loading"
                      ></i>
                    </up-button>
                  </up-upload>
                  <up-popover
                    v-if="scope.row.material"
                    placement="top"
                    width="160"
                    v-model="visibles[scope.$index]"
                    hasFooter
                    @up:confirm="handleOnRemove(scope)"
                  >
                    <p>确定要删除该素材吗？</p>
                    <up-button slot="reference" size="small" class="is-remove ml5" type="primary">
                      删除
                      <i v-if="removing[scope.$index]" class="el-icon el-icon-loading"></i>
                    </up-button>
                  </up-popover>
                </template>
              </up-table-column>
            </template>
          </up-table>
        </up-form-item>
        <!-- 开屏交互引导文案  -->
        <up-form-item-input v-if="isOpenScreen" label="开屏引导文案" class="w364" placeholder="请输入开屏引导文案, 不超过14字" prop="open_screen_guide_text" v-model="form.open_screen_guide_text"></up-form-item-input>
        <el-form-item class="btnGroups">
          <el-button
            v-if="!isShow"
            size="large"
            type="primary"
            @click="ad_urlForm('form')"
            :disabled="committing"
          >{{committing ? '提交中···' : '提交'}}</el-button>
          <el-button size="large" class="is-cancel" @click="cancel">{{isShow ? '返回': '取消'}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex'
import { headPanel, NyArea } from '@/global/components'
import { post, get, put } from '@/manager/http/index'
import { comdify, delcommafy, groupBy } from '@/global/util/util'

import bus from '@/global/util/bus'

const h = bus.$createElement

const REGEXP_WEBSITE_URL = /^https?:\/\//
export default {
  data() {
    const validateAdUrl = async (rule, value, callback) => {
      this.validAdUrl = false
      this.hasCheckedAdUrl = this.lastAdUrl === value
      if (value === '') {
        callback(new Error('请输入落地页URL'))
      } else if (!REGEXP_WEBSITE_URL.test(value)) {
        callback(new Error('落地页URL必须输入以 http 或 https 开头'))
      } else {
        if (this.form.conversion_monitor_type === '') { // 未选择落地页转化监测
          this.$refs.form.validateField('conversion_monitor_type')
        } else {
          if (!this.hasCheckedAdUrl) await this.checkAdUrl()
          else {
            this.validAdUrl = true
          }
          callback()
          // const valid = await this.checkAdUrl()
          // if (!valid) {
          //   callback(new Error('落地页URL异常无法解析，请重新输入'))
          // } else {
          //   callback()
          // }
        }
      }
    }
    let validateFallbackName = (rule, value, callback) => {
      let self = this
      if (value === '') {
        callback(new Error('请输入广告名称'));
      } else if (value.length > 50) {
        callback(new Error('输入内容不得超过50个字符'));
      } else {
        this['fallbackAd/isRepeatedName']({ ad_name: value }).then(res => {
          // status =1 重名 status = 0 未重名
          if (res.data.status === 1 && value !== self.editName) {
            callback(new Error('广告名称已存在，请重新输入'))
          }
          callback();
        })
      }
    };
    const ad_urlRelated = (message) => async (rule, value, callback) => {
      if (value === '') {
        callback(new Error(message))
      } else if (this.form.ad_url) { // 已经输入了落地页URL
        this.$refs.form.validateField('ad_url')
      } else {
        callback()
      }
    }
    const validateFilenames = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请上传素材'))
      } else if (this.isFlow) {
        if (this.form.information === '2' && value.length !== 3) {
          callback(new Error('组图素材必须上传三张图片'))
        } if (['1', '3'].includes(this.form.information) && value.length < 1) {
          callback(new Error(`${this.form.information === '1' ? '小图' : '大图'}素材至少上传一张图片！`))
        } else {
          callback()
        }
      } else if (this.isMotivate) { // 激励视频
        const groupedMtData = groupBy(value, 'material_type')

        if (Object.keys(groupedMtData).length > 0) {
          if (!groupedMtData[1]) { // 图片
            callback(new Error('必须上传一个主素材'))
          } else if (!groupedMtData[2]) {
            callback(new Error('必须上传一张封面图片'))
          } if (!groupedMtData[3]) {
            callback(new Error('必须上传一张icon图片'))
          } else {
            callback()
          }
        } else {
          callback(new Error('主素材、封面、icon 必须各上传一张'))
        }

        // if (groupedData) {

        // }
        callback(new Error('kkkkkkk'))
      } else {
        callback()
      }
    }
    const validateConversionMonitorType = async (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择落地页转化监测'))
      } else if (this.form.ad_url) { // 已经输入了落地页URL
        this.$refs.form.validateField('ad_url')
      } else {
        callback()
      }
    }
        const validateApkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入包名'))
      } else if (value.length > 100) {
        callback(new Error('包名超过不能100个字符'))
      } else {
        const regx = /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/
        if (!regx.test(value)) {
          callback(new Error('格式须符合 xx.xx.xx或 xx.xx.xx.xx。包名每段需由字母开头'))
        } else {
          callback()
        }
      }
    }
    const validateAppID = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入AppID'))
      } else if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        callback(new Error('AppID需为数字'))
      } else {
        callback()
      }
    }
    this.defaultMaterialImage = require('../../assets/default.png')
    this.materialTypes = ['', '主素材', '封面', 'icon']

    return {
      order_title: '',
      platform: '',
      os_list: '',
      editName: '', // 获取详情广告名称
      isAdd: true,
      isShow: false,
      loading: false,
      isDetails: false,
      type: '',
      committing: false, // 是否正在提交
      jumpTypes: [], // 跳转行为
      adUrlTxt: '', // 落地页检测结果
      checking: false,
      validAdUrl: false, // 落地页是否合法
      isAdUrlPicExist: false, // 落地页图片是否存在
      hasCheckedAdUrl: false, // 是否已经验证过了
      lastAdUrl: '', // 上一个 url
      fileList: [],
      isMotivate: false, // 是否是激励视频
      isBanner: false, // 是否是banner
      defaultProvinces: [], // 默认选中的省份
      provinces: {
        entire: [],
        provinces: []
      },
      form: {
        ad_name: '',
        place_attribute: '',
        port_type: '',
        flow_type: '',
        jump_type: '',
        deeplink: '',
        ad_url: '',
        apk_name: '',
        conversion_monitor_type: '',
        title: '',
        spread_name: '',
        filenames: [],
        provinces: [], // cpt 投放地域
        open_screen_guide_text: '', // 根据跳转行为展示默认文字
      },
      rules: {
        ad_name: [{ required: true, validator: validateFallbackName, trigger: 'blur' }],
        title: [{ required: false, message: '请输入广告标题', trigger: 'blur' }],
        spread_name: [{ required: true, message: '请输入广告描述', trigger: 'blur' }],
        flowType: [{ required: true, message: '请选择流量类型', trigger: 'change' }],
        portType: [{ required: true, message: '请选择投放终端', trigger: 'change' }],
        placeAttr: [{ required: true, message: '请选择广告位属性', trigger: 'change' }],
        apk_name: [
          { required: true, validator: validateApkName, trigger: 'blur' }
        ],
        app_id: [
          { required: true, validator: validateAppID, trigger: 'blur' }
        ],
        jump_type: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
        conversion_monitor_type: [{ required: true, validator: validateConversionMonitorType, trigger: 'change' }],
        ad_url: [{ required: true, validator: validateAdUrl, trigger: 'blur' }],
        provinces: [{ type: 'array', required: true, message: '请选择投放地域', trigger: 'change' }],
        filenames: [{ type: 'array', required: true, validator: validateFilenames, trigger: 'change' }],
        open_screen_guide_text: [
          { required: true, message: '请输入开屏交互引导文案', trigger: 'blur' },
          { max: 14, message: '引导文案不能超过14个字', trigger: 'blur' }
        ]
      },
      materialFileList: [],
      page: new this.$page({
        header: { no: '编号', material: '素材', material_size: '素材大小', material_name: '素材地址', upload_status: '上传状态' }
        // header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' }
      }),
      preview: { // 预览
        visible: false,
        activeIndex: -1,
        data: []
      },
      conversionMonitorTypes: [],
      visibles: [],
      removing: [],
      uploading: []
    }
  },
  computed: {
    ...mapGetters({
      fallback: 'fallbackAd/fallback',
      userid: 'login/userid'
    }),
    disabledAdUrl() {
      return !this.validAdUrl || this.isAdUrlPicExist
    },
    disabledField() {
      return !this.isAdd
    },
    isOpenScreen() { //是否开屏广告
      return this.form.place_attribute === '1'
    },
    isAndroid() {
      return this.form.port_type === '2'
    },
    isIos() {
      return this.form.port_type === '1'
    }
  },
  async created() {
    this.loading = true
    this.platform = this.$router.currentRoute.meta.platform;
    this.isShow = this.$route.params.type === 'show'
    this.isAdd = !this.$route.params.id
    this.order_title = this.$route.params.id ? (this.isShow ? '查看' : '编辑') : '添加'
    await this.init()
    this.loading = false
  },
  methods: {
    ...mapActions([
      'fallbackAd/getMaterialSizes',
      'fallbackAd/checkAdUrl',
      'fallbackAd/uploadPicture',
      'fallbackAd/uploadVideo',
      'fallbackAd/uploadMaterialCut',
      'fallbackAd/getMaterialSizes',
      'fallbackAd/getItems',
      'fallbackAd/handleOnRemove',
      'fallbackAd/isRepeatedName'
    ]),
    async init() {
      this.getAdvertiserList()
      await this.$store.dispatch('fallbackAd/getCommonPlace', {
        params: 'flow_type',
        data: {
          platform: this.platform
        },
        api: 'FALLBACK_AD_FLOW_TYPE_MENU'
      })
      this.form.flow_type = this.fallback.curFlowType
      const items = new Map()
        .set('conversion_monitor_type', 'conversionMonitorTypes')
        .set('provinces', 'provinces')
      // .set('create_type', 'createTypes')
      // .set('information', 'informations')
      const itemValues = [...items.values()]
      this['fallbackAd/getItems']({ keys: items.keys() })
        .then(results => {
          results.forEach((res, i) => {
            this[itemValues[i]] = res.data
          })

          if (!this.id) this.loading = false
        })
      await this.getPortTypeMenu(this.form.flowType)
      this.form.port_type = this.fallback.curPortType

      if (this.$route.params.id) {
        await this.getOrderDetails()
        this.isDetails = true
      }
    },
    getAdvertiserList() { // 获取广告主列表数据
      // this.$store.dispatch('advertiserList')
    },
    async getOrderDetails() {
      await get('/inner/v2/basicAd/' + this.$route.params.id).then(async res => {
        if (res.code === 1) {
          const {
            material: materialBox,
            ad_name,
            conversion_monitor_type,
            ad_url,
            apk_name,
            deeplink,
            create_type,
            place_attribute,
            port_type,
            flow_type,
            jump_type,
            id,
            provinces,
            open_screen_guide_text
          } = res.data[0]
          // eslint-disable-next-line camelcase
          const { title, spread_name, files } = materialBox[0]
          this.form.flow_type = flow_type + ''
          this.form.port_type = port_type + ''
          this.form.provinces = provinces
          this.defaultProvinces = provinces
          this.form.place_attribute = place_attribute + ''
          // await this.getPlaceAttrMenu()
          if (this.$route.params.type === 'edit') {
            this.editName = ad_name
          }
          this.getPlaceAttrMenu()
          this.getJumpTypeMenu()
          this.form = Object.assign({}, this.form, {
            conversion_monitor_type: conversion_monitor_type + '',
            ad_url,
            ad_name,
            apk_name,
            deeplink,
            title,
            jump_type,
            spread_name,
            open_screen_guide_text
          })
          await this.getMaterialSizes()
          this.page.setData({
            data: this.page.data.map(item => {
              // const material = materials.find(material => String(item.ratio_id) === String(material.ratio_id) || item.minimum_upload_size === material.size)
              const material = files.find(material => String(item.ratio_id) === String(material.ratio_id))
              if (material) {
                return {
                  ...item,
                  id: this.type !== 'copy' ? material.id : undefined,
                  cut_path: material.cut_path,
                  cut_size: item.minimum_upload_size,
                  material: material.path,
                  width: material.width,
                  height: material.height,
                  file_size: material.file_size,
                  seconds: material.seconds,
                  material_size: material.size
                }
              }
              return item
            })
          })

          const ratioIds = this.page.data.map(item => String(item.ratio_id))
          files.forEach(item => {
            if (!ratioIds.includes(String(item.ratio_id))) {
              this.page.data.push({
                ...item,
                no: this.page.data.length + 1,
                cut_path: item.cut_path,
                cut_size: item.size,
                material: item.path,
                width: item.width,
                height: item.height,
                seconds: item.seconds,
                file_size: item.file_size,
                material_size: item.size,
                minimum_upload_size: item.size
              })
            }
          })
          this.form = Object.assign({}, this.form, {
            filenames: this.page.data.reduce((acc, item, index) => {
              if (item.material) {
                acc.push({
                  id: this.type !== 'copy' ? item.id : undefined,
                  path: item.material,
                  size: item.material_size,
                  cut_path: item.cut_path || item.material,
                  ratio_id: item.ratio_id,
                  no: item.no,
                  width: item.width,
                  height: item.height,
                  seconds: item.seconds,
                  file_size: item.file_size,
                  create_type: item.create_type,
                  material_type: item.material_type
                })
              }
              return acc
            }, [])
          })
        }
      })
      // if (this.form.payment !== 'cpt') { this.$refs['order'].validateField('putNum') }
    },
    async getPortTypeMenu({ flowType, def } = {}) {
      await this.$store.dispatch('fallbackAd/getCommonPlace', {
        params: 'port_type',
        data: {
          platform: this.platform,
          flow_type: flowType || this.form.flow_type
        },
        api: 'FALLBACK_AD_PORT_TYPE_MENU'
      })
      if (this.isAdd) { this.form.port_type = this.fallback.curPortType }
      if (this.form.port_type) {
        await this.getPlaceAttrMenu()
      }
    },
    async getPlaceAttrMenu({ flowType, portType } = {}) {
      await this.$store.dispatch('fallbackAd/getCommonPlace', {
        params: 'place_attribute',
        data: {
          platform: this.platform,
          port_type: portType || this.form.port_type,
          flow_type: flowType || this.form.flow_type
        },
        api: 'FALLBACK_AD_PLACE_ATTRIBUTE_MENU'
      })
      if (this.isAdd) {
        this.form.place_attribute = this.fallback.curPlaceAttr
        if (this.form.place_attribute) {
          await this.getJumpTypeMenu()
          await this.getMaterialSizes()
        }
      }
    },
    async getJumpTypeMenu({ flowType, portType, placeAttribute } = {}) {
      await this.$store.dispatch('fallbackAd/getCommonPlace', {
        params: 'jump_type',
        data: {
          platform: this.platform,
          port_type: portType || this.form.port_type,
          flow_type: flowType || this.form.flow_type,
          place_attribute: placeAttribute || this.form.place_attribute
        },
        api: 'FALLBACK_AD_JUMP_TYPE_MENU'
      })
      if (this.isAdd) { this.form.jump_type = this.fallback.curJumpType }
    },
    async isRepeatOrderName() { // 判断计划是否重名
      let flag = false
      if (this.form.name !== '') {
        await this.$store.dispatch('orderNameIsRepeat', { data: this.form.name, mediaType: this.mediaType }).then((data) => {
          if (data && data.code === 1 && data.data.status === 1) {
            flag = true
          } else {
            flag = false
          }
        })
      }
      return flag
    },
    changeCode(name) {
      this.$nextTick(() => {
        if (this.order[name] !== null) {
          this.order[name] = this.order[name].replace(/[^\d]/g, '')
        }
      })
    },
    changeComdify(form, name) {
      this.$nextTick(() => {
        if (this[form][name] !== null) {
          this[form][name] = comdify(delcommafy(this[form][name]))
        }
      })
    },
    flowTypeChange(value) {
      this.getPortTypeMenu()
    },
    portTypeChange(value) {
      this.placeAttrChange()
    },
    placeAttrChange(value) {
      this.isMotivate = this.form.place_attribute === '11'
      this.isBanner = this.form.place_attribute === '3'
      this.getJumpTypeMenu()
      this.getMaterialSizes()
    },
    handleChange(type, value) { //
      this.form.curCity = value
    },
    // 更新跳转行为
    handleChangeJumpType() {
      if (this.isAdd) {
        const openScreenMsg = {
          '1': '点击跳转详情页或第三方应用',
          '2': '点击下载或跳转第三方应用',
          '3': '点击跳转详情页或第三方应用'
        }
        this.form.open_screen_guide_text = openScreenMsg[this.form.jump_type]
      }
    },
    handleAdUrlChange() {
      this.form.ad_url = this.form.ad_url.replace(/\s+/g, '') // 移除空格
    },
    openAdUrl() {
      window.open(this.form.ad_url, '_tab')
    },
    dataFilter(date) {
      let arr = []
      date.forEach(time => {
        let temp = []
        time.time.forEach(t => {
          if (t.length === 1) {
            temp.push(t < 10 ? ['0' + t, '0' + (parseInt(t) + 1)] : [t + '', (parseInt(t) + 1) + ''])
          } else {
            temp.push(t.map((v, i) => {
              if (i === 1) {
                v = parseInt(v) + 1
              }
              return v < 10 ? '0' + parseInt(v) : v + ''
            }))
          }
        })
        arr.push({
          date: time.date,
          time: temp
        })
      })
      return arr
    },
    async handleAdPlanChange(value) {
      const { information } = this.plans.find(v => v.id === value) || {}
      this.form.information = information
      await this.getMaterialSizes(value) // 获取素材尺寸
      // 更新素材状态，处理 filenames
      this.form.filenames.splice(0)
    },
    async checkAdUrl() {
      const { conversion_monitor_type: type, ad_url: url, jump_type: jumpType } = this.form
      this.adUrlTxt = ''
      this.checking = true
      const [err, res] = await this['fallbackAd/checkAdUrl']({ platform: this.platform, type, url, jumpType })
      this.adUrlTxt = res.msg
      this.checking = false
      if (err || res.code !== 1) { // 验证失败
        this.validAdUrl = false
      } else { // 成功
        this.validAdUrl = true
        this.isAdUrlPicExist = res.data && res.data.status === 1
      }
      this.lastAdUrl = url // 上一个 url
      return this.validAdUrl
    },
    async uploadPicture(file, isMaterial) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('information', this.form.information || '0')
      return await this['fallbackAd/uploadPicture']({ platform: this.platform, isMaterial, formData })
    },
    async uploadVideo(file, ratioId) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('ratio_id', ratioId)
      return await this['fallbackAd/uploadVideo']({ platform: this.platform, formData })
    },
    async uploadMaterialCut(file, size) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('cut_size', size)
      return await this['fallbackAd/uploadMaterialCut']({ platform: this.platform, formData })
    },
    beforeUploadAdUrl(file) {
      const isSupport = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.raw.type);
      const isLt150KB = file.raw.size / 1024 < 150;

      if (!isSupport) {
        this.$message.error('落地页长截图只能是 png, jpg, jpeg 格式！');
      }
      if (!isLt150KB) {
        this.$message.error('落地页长截图大小不能超过 150KB！');
      }
      return isSupport && isLt150KB
    },
    async handleOnChangeAdUrl(file, fileList) {
      if (!this.beforeUploadAdUrl(file)) return

      const [err, res] = await this.uploadPicture(file)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '上传落地页长截图失败！')
      else {
        this.fileList.splice(0, this.fileList.length, file)
        const { path } = res.data
        this.form.landing_page_pic = path
      }
    },

    async getMaterialSizes(adId) { // 获取素材尺寸
      const [err, res] = await this['fallbackAd/getMaterialSizes']({
        port_type: this.form.port_type,
        place_attribute: this.form.place_attribute
      })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取素材尺寸失败！')
      else {
        this.page.setData({
          data: res.data.map((item, index) => ({
            ...item,
            cut_path: '', // 裁切路径
            cut_size: '', // 裁切尺寸
            no: index + 1, // 编号
            material: '',
            material_size: ''
          }))
        })
        const length = this.page.data.length
        this.uploading = Array.from({ length }, Boolean)
        this.visibles = Array.from({ length }, Boolean)
        this.removing = Array.from({ length }, Boolean)
      }
    },
    beforeUploadPictureMaterial(file) {
      const isSupport = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'].includes(file.raw.type)
      const isLt150KB = file.raw.size / 1024 < 150;
      if (!isSupport) {
        this.$message.error('素材图片只能是 png, jpg, jpeg, gif 格式！');
      }
      if (!isLt150KB) {
        this.$message.error('素材图片大小不能超过 150KB！');
      }
      return isSupport && isLt150KB
    },
    beforeUploadVideoMaterail(file) {
      const isSupport = ['video/mp4'].includes(file.raw.type);
      const isLt50M = file.raw.size / 1024 / 1024 < 50;

      if (!isSupport) {
        this.$message.error('素材视频只能是 mp4 格式！');
      }

      if (!isLt50M) {
        this.$message.error('素材视频大小不能超过 50MB！');
      }

      return isSupport && isLt50M;
    },
    handleProvinceChange(value) {
      if (value.length > 0) this.$refs.form.clearValidate('provinces')
    },
    async handleOnRemove({ row, $index }) {
      if (row.id) { // 已保存到数据库的素材
        if (this.removing[$index]) return
        this.removing.splice($index, 1, true)
        const [err, res] = await this['fallbackAd/handleOnRemove']({ ids: row.id })
        this.removing.splice($index, 1, false)
        if (err || res.code !== 1) return this.$message.error((err || res).msg || '删除素材失败！')
      }

      this.visibles.splice($index, 1, false)
      // 重置
      this.page.data = this.page.data.map(item => {
        if (item.no === row.no) {
          return {
            ...item,
            cut_path: '', // 裁切路径
            cut_size: '', // 裁切尺寸
            material: '',
            material_size: ''
          }
        }
        return item
      })
      this.form.filenames = this.form.filenames.filter(item => item.no !== row.no)
      this.$message.success('删除素材成功！')
    },
    handleCellClick(row, column) {
      if (column.property === 'material' && row.material) {
        this.preview.data = this.page.data.filter(item => item.material)
        this.preview.activeIndex = this.page.data.indexOf(row)
        this.preview.visible = true
      }
    },
    isMatchVideo(size) {
      size = this.page.data.filter(v => v.create_type === 2)
        .find(v => v.size === size || v.minimum_upload_size === size)
      return [!!size, size]
    },
    /**
     * 上传素材
     */
    async handleOnChange(file, fileList, scope) {
      // 是否选择了素材类型
      /*  if (!this.form.create_type) {
        this.$message.error('请先选择素材类型！')
        return this.$refs.form.validateField('create_type')
      } */
      // 校验素材类型
      if (this.isMotivate) { // 激励视频
        if (scope.row.create_type === 1 && !this.beforeUploadPictureMaterial(file, !!scope.row.material, scope.row.material_type)) return
        if (scope.row.create_type === 2 && !this.beforeUploadVideoMaterail(file, !!scope.row.material)) return
      } else {
        if (scope.row.create_type === 1 && !this.beforeUploadPictureMaterial(file)) return
      }

      // 是否正在上传
      if (this.uploading[scope.$index]) return
      this.uploading.splice(scope.$index, 1, true)

      // 上传
      let err, res
      if (this.isMotivate) {
        if (scope.row.create_type === 2) {
          [err, res] = await this.uploadVideo(file, scope.row.ratio_id)
        } else {
          [err, res] = await this.uploadMaterialCut(file, scope.row.ratio_id)
        }
      } else {
        [err, res] = await this.uploadMaterialCut(file, scope.row.minimum_upload_size)
      }

      this.uploading.splice(scope.$index, 1, false)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '上传素材失败！')
      else {
        const { path, size, seconds, file_size: fileSize, cut_path: cutPath, cut_size: cutSize } = res.data
        const width = size.split('*')[0]
        const height = size.split('*')[1]
        if (scope.row.create_type === 2) { // 视频
          const [matched] = this.isMatchVideo(size)
          if (!matched) {
            this.$message.error('素材视频尺寸不匹配，请重新上传')
            return
          }
        }

        this.page.setData({
          data: this.page.data.map((item, index) => {
            if (scope.$index === index) {
              return {
                ...item,
                cut_path: cutPath,
                cut_size: cutSize,
                material: path,
                material_size: size,
                create_type: scope.row.create_type,
                material_type: scope.row.material_type
              }
            }
            return item
          })
        })
        if (scope.row.material) { // 替换
          this.form.filenames = this.form.filenames.map(item => {
            if (item.no === scope.row.no) {
              return ({
                ...item,
                path,
                width,
                height,
                seconds: seconds || 0,
                file_size: fileSize || 0,
                cut_path: cutPath
              })
            }
            return item
          })
        } else { // 上传
          this.form.filenames.push({
            cut_path: cutPath,
            path,
            width,
            height,
            no: scope.row.no,
            ratio_id: scope.row.ratio_id,
            create_type: scope.row.create_type,
            material_type: scope.row.material_type,
            seconds: seconds || 0,
            file_size: fileSize || 0
          })
        }
        this.$refs.form.validateField('filenames')
      }
    },
    getParams() {
      // eslint-disable-next-line camelcase
      const { apk_name: apkName, open_screen_guide_text, provinces, deeplink, conversion_monitor_type: cmt, title, spread_name, filenames, ...params } = this.form
      params.filenames = [{
        title,
        spread_name,
        files: filenames
      }]
      params.open_screen_guide_text = this.isOpenScreen ? open_screen_guide_text : ''
      return {
        apk_name: this.form.jump_type === '2' ? apkName : '',
        deeplink: this.form.jump_type === '3' ? deeplink : '',
        conversion_monitor_type: this.form.jump_type !== '2' ? cmt : '',
        provinces: provinces.join(','),
        ...params
      }
    },
    ad_urlForm(numberValidateForm) {
      this.$refs[numberValidateForm].validate((valid, errors) => {
        this.getParams()
        if (valid) {
          this.committing = true
          let self = this
          let data = self.getParams()
          if (self.$route.params.id && self.$route.params.type === 'edit') {
            put('/inner/v2/basicAd/' + self.$route.params.id, data).then(res => {
              if (res.code === 1) {
                this.committing = false
                self.$message('提交成功')
                self.$router.push('/advertise/fallback')
              } else {
                this.committing = false
                self.$message.error(res.msg)
              }
            }).catch(() => {
              this.committing = false
            })
            return false
          }
          post('/inner/v2/basicAd', data).then(res => {
            if (res.code === 1) {
              this.committing = false
              self.$message('提交成功')
              self.$router.push('/advertise/fallback')
            } else {
              self.$message.error(res.msg)
              this.committing = false
            }
          }).catch(() => {
            this.committing = false
          })
        } else {
          // this.$message.error('请填写完整信息！')
          this.$message.error({
            message: h('div', { class: 'el-message__content' }, [
              h('p', {}, '请填写完整信息！'),
              h('br'),
              h('ol', { style: { 'list-style-type': 'decimal', 'padding-left': '15px' } }, Object.keys(errors).map(key => h('li', {}, errors[key][0].message)))
            ])
          })
          this.verifying = false
          return false
        }
      });
    },
    cancel() {
      this.$router.push('/advertise/fallback');
    }
  },
  components: {
    headPanel,
    NyArea
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.fallback-ad-edit {
  position: relative;
  .ruleForm {
    .input_sm {
      width: 210px;
      .el-select {
        width: 210px;
      }
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
  }
  .rule_form_radio {
    max-width: 850px;
    text-align: left;
    .el-radio {
      line-height: 30px;
      margin-left: 0;
      margin-right: 16px;
    }
  }
  .position {
    .el-col {
      width: 210px;
      margin-right: 20px;
    }
  }
  .date-panel-2 .finallyDate {
    margin-left: 16px;
  }
  .date-panel-2 .date-range2 {
    left: 16px;
  }
  .order-area .put-area {
    display: inline-block;
  }
  .goList {
    color: #65cea7;
    cursor: pointer;
  }
  .i-question-box {
    position: relative;
    .icon-iconfontquestion {
      position: absolute;
      top: 1px;
      left: -10px;
      color: #fc8675;
      cursor: pointer;
    }
  }
}
@include b(fallback-ad-edit) {
  @include e(landpage) {
    position: relative;

    .icon-iconfontquestion {
      color: #fc8675;
    }
  }

  @include e(landpage-message) {
    @include is(correct) {
      color: #66cfa7;
    }
    @include is(wrong) {
      color: #fc8675;
    }
  }

  @include e(landpage-upload) {
    .el-upload {
      margin-left: 16px;
    }
  }

  @include e(landpage-tip) {
    position: absolute;
    top: 0;
    left: 170px;
  }

  @include e(landpage-pic) {
    margin-left: 16px;
    max-width: 364px;
    max-height: 200px;

    img {
      max-width: 100%;
      max-height: 200px;
      height: auto;
    }
  }
  @include e(table-material) {
    display: block;
    width: 100%;
    height: auto;
  }

  @include e(table-material-size) {
    text-align: left;

    span {
      @include is(recommend) {
        color: #e21d25;
      }
    }
  }

  @include e(table-remark) {
    font-size: 12px;
    color: #999;
  }

  @include e(material-size) {
    span {
      color: #999;

      &:last-child {
        margin-left: 20px;
      }
    }
  }

  @include e(upload-tip) {
    margin-left: 16px;
    font-size: 12px;
    color: #fc8675;
  }

  @include e(table) {
    margin-top: 16px;
    margin-left: 16px;

    .icon-right {
      color: #66cfa7;
    }

    .icon-wrong {
      color: #fc8675;
    }

    .is-path {
      text-decoration: underline;
      color: #1c8de0;
    }

    .is-preview {
      max-width: 100%;
      max-height: 100px;
      margin: 0 auto;
    }
  }

  @include e(replace) {
    display: inline-block;
  }
}
</style>
